import { render, staticRenderFns } from "./menu_section.vue.js?vue&type=template&id=367d722f&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu_section.vue?vue&type=template&id=367d722f&vue3"
import script from "./menu_section.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu_section.vue?vue&type=script&lang=js&vue3"
export * from "./menu_section.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu_section.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports